import { breakpoints } from "../tokens/breakpoints";

/**
 * Inject breakpoint tokens as CSS custom properties on the document root
 */
export const injectBreakpoints = () => {
  const root = document.documentElement;

  // Inject breakpoint values as CSS variables
  Object.entries(breakpoints).forEach(([key, value]) => {
    root.style.setProperty(`--breakpoint-${key}`, value);
  });
};
